// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    undoAll: {
        id: 'schedule.undo-all',
        defaultMessage: 'Undo All',
        description: 'Undo all changes made in the schedule'
    },
    save: {
        id: 'schedule.save',
        defaultMessage: 'Save',
        description: 'Save changes made in the schedule'
    },
    close: {
        id: 'schedule.close',
        defaultMessage: 'Close',
        description: 'Collapse the selected day'
    },
    // Messages
    addEvent: {
        id: 'schedule.add-event',
        defaultMessage: 'To add a new time slot, choose the day you want to add it to'
    },
    addEventSelectedDay: {
        id: 'schedule.add-event-selected-day',
        defaultMessage: 'Now choose where you would like it to be added'
    },
    addEventMaxEvents: {
        id: 'schedule.add-event-max-events',
        defaultMessage: 'Sorry you cannot add more time slots on this day! The maximum allowed was reached'
    },
    copyDayEventsCopyFrom: {
        id: 'schedule.copy-day-events-copy-from',
        defaultMessage: 'Select the day you want to copy from'
    },
    copyDayEventsCopyTo: {
        id: 'schedule.copy-day-events-copy-to',
        defaultMessage: 'Now select the days you want to copy to'
    },
    deleteEvent: {
        id: 'schedule.delete-event',
        defaultMessage: 'To remove a time slot, choose the day you want to remove from'
    },
    deleteEventSelectedDay: {
        id: 'schedule.delete-event-selected-day',
        defaultMessage: 'Now select the time slot you want to remove'
    },
    deleteEventMinEvents: {
        id: 'schedule.delete-event-min-events',
        defaultMessage: 'Sorry you cannot remove the only time slot of the day'
    },
    // tooltip
    tooltipMessage: {
        id: 'schedule.tooltip-message',
        defaultMessage: "Click here to change this timeslot's value"
    },
    resetSchedule: {
        id: 'schedule.reset-schedule',
        defaultMessage: 'Reset Schedule'
    },
    savingSchedule: {
        id: 'schedule.saving-schedule',
        defaultMessage: 'Saving Schedule'
    },
    // Hue
    hueWarningMessage: {
        id: 'schedule-picker.hue-warning-message',
        defaultMessage: `Philips Hue Routines and Timers will remain active if not disabled.`
    }
});



// WEBPACK FOOTER //
// ./src/core/domains/schedule/intl.js